// To override Launch Darkly settings to turn on a flag
// you may set the flag value to true (boolean, not string)
export const POST_TO_RECURRING_SHIFTS = 'req_post_to_recurring_shifts'; // always on in production
export const RMJ_WORKER_SCHEDULE = 'rmj_worker_schedule'; // always off in production
export const REACT_LOGIN = 'w-2-login-page'; // can only be GA or off -- always off in production
export const DMD_REACT_PORTAL = 'dmd_react_portal'; // always off in production
export const DMD_MODULAR_ORDER_FORM = 'dmd_modular_order_form'; // always on in production
export const DMD_MOFO_LOCATION_DETAILS = 'dmd_mofo_location_details'; // always on in production
export const DMD_NEW_LOCATION_FORM = 'dmd_new_location_form'; // always on in production
export const DMD_MOFO_REPOST = 'dmd_position_repost'; // always on in production
export const DMD_MOFO_CONTACTS = 'dmd_mofo_contacts'; // always on in production
export const DMD_LOCATION_MANAGEMENT = 'dmd_mofo_manage_locations'; // always on in production
export const MANAGE_POSITIONS = 'dmd_mofo_manage_positions'; // always on in production
export const MANAGE_SCHEDULES = 'dmd_manage_schedules'; // always on in production
export const DMD_POST_EXTENSIONS = 'dmd_post_extensions'; // always on in production
export const DMD_CAPTCHA = 'dmd_captcha'; // always off in production
export const DMD_MANAGE_CANCELLATION_IMPROVEMENTS = 'dmd_manage_cancellation_improvements'; // always on in production
export const DMD_AUTO_APPROVED_ENABLED = 'dmd_auto_approve_enabled'; // always on in production
export const DMD_EDIT_POSITIONS = 'dmd-position-edits'; // always on in production
export const DMD_EDIT_JOBS = 'dmd-job-edits'; // always on in production

// List of feature flags that should always return true
export const AUTO_ENABLED_FLAGS = [
  POST_TO_RECURRING_SHIFTS,
  DMD_MODULAR_ORDER_FORM,
  DMD_MOFO_LOCATION_DETAILS,
  DMD_NEW_LOCATION_FORM,
  DMD_MOFO_REPOST,
  DMD_MOFO_CONTACTS,
  DMD_LOCATION_MANAGEMENT,
  MANAGE_POSITIONS,
  MANAGE_SCHEDULES,
  DMD_POST_EXTENSIONS,
  DMD_MANAGE_CANCELLATION_IMPROVEMENTS,
  DMD_AUTO_APPROVED_ENABLED,
  DMD_EDIT_POSITIONS,
  DMD_EDIT_JOBS,
];

// List of feature flags that should always return false
export const AUTO_DISABLED_FLAGS = [
  RMJ_WORKER_SCHEDULE,
  DMD_REACT_PORTAL,
  REACT_LOGIN,
  DMD_CAPTCHA,
];
